/** Ant Design picker popup class for Quick Schedule (avoids modal overflow clipping). */
export const QUICK_SCHEDULE_DATE_PICKER_POPUP_CLASS = 'quickScheduleNewDatePickerPopup';

export const getQuickScheduleDatePickerPopupContainer = () => document.body;

/** Label layout variants for Step 3 date/time sections (Create Ride + Quick Schedule). */
export const DATE_TIME_LABEL_VARIANT = {
  DEFAULT: 'default',
  SCHEDULE_RIDE: 'scheduleRide',
  ROUND_TRIP: 'roundTrip',
};

/** User-facing field and section labels for pickup, return, and recurring date/time. */
export const DATE_TIME_FIELD_LABELS = {
  PICKUP_SECTION_TITLE: 'Pickup Date and Time Information:',
  APPOINTMENT_DETAILS_TITLE: 'Appointment Details:',
  MULTI_TRIP_OPTIONS_TITLE: 'Multi-Trip Options:',
  APPOINTMENT_CHECKBOX: 'This rider is being picked up to go to an appointment',
  TIMEZONE: 'Time zone',
  APPOINTMENT_DATE_TIME: 'Appointment Date & Time',
  APPOINTMENT_PLACEHOLDER: 'Select Date & Time',
  FLEXIBLE_PICKUP_CHECKBOX: 'This pickup time is flexible',
  PICK_UP_DATE_TIME: 'Pickup Date & Time',
  PICK_UP_DATE_TIME_RETURN_TRIP: 'Pick Up Date and Time for Return Trip',
  LATEST_PICKUP_TIME: 'Latest Pickup Time',
  LATEST_PICKUP_TIME_DEFAULT: 'Latest pickup time',
  EARLIEST_PICKUP_TIME: 'Earliest Pickup Time',
  EARLIEST_PICKUP_TIME_DEFAULT: 'Earliest pickup time',
  END_RETURN_PICKUP_FLEXIBLE: 'End Pick Up Date and Time for Return Trip',
  START_RETURN_PICKUP_FLEXIBLE: 'Start Pick Up Date and Time for Return Trip',
  RECURRING_START_LEG_1: 'Start point of Recurring ride, leg 1',
  RECURRING_START_SINGLE: 'Start point of Recurring ride',
  RECURRING_START_LEG_2: 'Start point of Recurring ride, leg 2',
  INVALID_PICKUP_WINDOW_TITLE: 'Selected Pick Up Date & Time is not valid',
  INVALID_PICKUP_WINDOW_CONTENT:
    'You have picked a time outside of the window. Please pick a better time and try again',
};

export const isScheduleRideLayout = (labelVariant) =>
  labelVariant === DATE_TIME_LABEL_VARIANT.SCHEDULE_RIDE ||
  labelVariant === DATE_TIME_LABEL_VARIANT.ROUND_TRIP;

export const getPickUpDateFieldLabel = ({ labelVariant, isPickUpDateFlexible }) => {
  if (labelVariant === DATE_TIME_LABEL_VARIANT.ROUND_TRIP) {
    return isPickUpDateFlexible
      ? DATE_TIME_FIELD_LABELS.LATEST_PICKUP_TIME
      : DATE_TIME_FIELD_LABELS.PICK_UP_DATE_TIME_RETURN_TRIP;
  }
  if (labelVariant === DATE_TIME_LABEL_VARIANT.SCHEDULE_RIDE) {
    return isPickUpDateFlexible
      ? DATE_TIME_FIELD_LABELS.LATEST_PICKUP_TIME
      : DATE_TIME_FIELD_LABELS.PICK_UP_DATE_TIME;
  }
  return isPickUpDateFlexible
    ? DATE_TIME_FIELD_LABELS.LATEST_PICKUP_TIME_DEFAULT
    : DATE_TIME_FIELD_LABELS.PICK_UP_DATE_TIME;
};

export const getEarliestPickUpLabel = (labelVariant) => {
  if (labelVariant === DATE_TIME_LABEL_VARIANT.ROUND_TRIP) {
    return DATE_TIME_FIELD_LABELS.EARLIEST_PICKUP_TIME;
  }
  return labelVariant === DATE_TIME_LABEL_VARIANT.SCHEDULE_RIDE
    ? DATE_TIME_FIELD_LABELS.EARLIEST_PICKUP_TIME
    : DATE_TIME_FIELD_LABELS.EARLIEST_PICKUP_TIME_DEFAULT;
};

export const getReturnDateFieldLabel = ({ labelVariant, isReturnDateFlexible }) => {
  if (labelVariant === DATE_TIME_LABEL_VARIANT.ROUND_TRIP) {
    return isReturnDateFlexible
      ? DATE_TIME_FIELD_LABELS.LATEST_PICKUP_TIME
      : DATE_TIME_FIELD_LABELS.PICK_UP_DATE_TIME_RETURN_TRIP;
  }
  if (labelVariant === DATE_TIME_LABEL_VARIANT.SCHEDULE_RIDE) {
    return isReturnDateFlexible
      ? DATE_TIME_FIELD_LABELS.LATEST_PICKUP_TIME
      : DATE_TIME_FIELD_LABELS.PICK_UP_DATE_TIME;
  }
  return isReturnDateFlexible
    ? DATE_TIME_FIELD_LABELS.END_RETURN_PICKUP_FLEXIBLE
    : DATE_TIME_FIELD_LABELS.PICK_UP_DATE_TIME_RETURN_TRIP;
};

export const getReturnEarliestLabel = (labelVariant) => {
  if (labelVariant === DATE_TIME_LABEL_VARIANT.ROUND_TRIP) {
    return DATE_TIME_FIELD_LABELS.EARLIEST_PICKUP_TIME;
  }
  return labelVariant === DATE_TIME_LABEL_VARIANT.SCHEDULE_RIDE
    ? DATE_TIME_FIELD_LABELS.EARLIEST_PICKUP_TIME
    : DATE_TIME_FIELD_LABELS.START_RETURN_PICKUP_FLEXIBLE;
};

export const getRecurringStartPointTitle = (isRoundtrip) =>
  isRoundtrip
    ? DATE_TIME_FIELD_LABELS.RECURRING_START_LEG_1
    : DATE_TIME_FIELD_LABELS.RECURRING_START_SINGLE;
